import { useEffect, useState } from "react";
import Table from "../../components/common/Table/Table";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { transactionTableColumns } from "../../config/tableColumns";
import api from "../../api/ApiService";
import {
  incentiveClaimTypes,
  incentiveClaimTypesList,
} from "../../config/applicationStatusConfig";
import { installmentsList } from "../../config/appliedSchemesConfig";
import { formatDateTime } from "../../utils/utils";

const AdminTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const fetchTransactions = async (page = 1, perPage = 10, search = "") => {
    try {
      const response = await api.get("/payment/transactions", {
        params: {
          perPage,
          page,
          search,
        },
      });

      if (response?.data?.data) {
        const formatted = response.data.data.map((item, index) => {
          return {
            sr_no: (page - 1) * perPage + index + 1,
            caf_id: item.caf_id,
            unit_name: item.fullname,
            payment_mode: item.payment_mode,
            status: item.status,
            amount: item?.amount || "N/A",
            total_eligible_investment_after_non_eligible_deduction:
              item?.total_eligible_investment_after_non_eligible_deduction ||
              "N/A",
            total_max_capital_subsidy: item?.total_max_capital_subsidy || "N/A",
            subsidy:
              incentiveClaimTypesList.find((i) => i.value === item?.subsidy)
                .label || "N/A",
            installment:
              installmentsList.find((i) => i.value === item?.installment)
                .name || "N/A",
            created_at: formatDateTime(item.created_at),
          };
        });

        setTransactions(formatted);
        setTotalEntries(response.data.total);
      } else {
        setTransactions([]);
        setTotalEntries(0);
      }
    } catch (error) {
      console.error("Failed to fetch data", error);
    }
  };

  useEffect(() => {
    fetchTransactions(currentPage, rowsPerPage, searchQuery);
  }, [currentPage, rowsPerPage, searchQuery]);

  return (
    <DashboardLayout pageTitle="Transaction List" mainClass="p-6">
      <div className="flex h-12 nav-bg p-3 text-white font-semibold rounded-tr rounded-tl">
        Transaction List
      </div>
      <>
        <Table
          columns={transactionTableColumns}
          data={transactions}
          totalEntries={totalEntries}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={setRowsPerPage}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
      </>
    </DashboardLayout>
  );
};

export default AdminTransactions;
